import { ReactNode } from 'react'

import FunkityLogo from '@/assets/icons/FunkityLogo'

type AuthSplitLayoutProps = {
  children: ReactNode
}

export const AuthSplitLayout = ({ children }: AuthSplitLayoutProps) => {
  return (
    <div className="min-h-[100svh] flex w-full md:items-stretch">
      <div className="hidden max-w-[45%] object-cover md:flex w-[1800px] bg-brand-gran items-center justify-center">
        <FunkityLogo className="text-brand-turkos w-64 h-auto" />
      </div>

      <div className="flex flex-col w-full h-[100svh] md:h-auto md:w-[55%] md:justify-center md:items-center">
        <div className="w-full md:max-w-md p-6 flex flex-col items-center h-full md:h-auto md:py-16">
          {children}
        </div>
      </div>
    </div>
  )
}
